import React from "react";

const TypingIndicator = () => {
  return (
    <div className="message bot">
      <div className="flex-shrink-0">
        <div className="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center">
          {/* Bot avatar: robot (matches MessageBubble) */}
          <svg
            className="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth={1.8}
          >
            <path strokeLinecap="round" d="M12 3v3" />
            <circle cx="12" cy="2.5" r="1" fill="currentColor" stroke="none" />
            <rect x="4" y="6" width="16" height="12" rx="4" />
            <circle cx="9.2" cy="12" r="1.3" fill="currentColor" stroke="none" />
            <circle cx="14.8" cy="12" r="1.3" fill="currentColor" stroke="none" />
            <path strokeLinecap="round" d="M9.5 15.5h5M2 10.5v3M22 10.5v3" />
          </svg>
        </div>
      </div>

      <div className="message-bubble bot">
        <div className="typing-indicator">
          <div className="typing-dot"></div>
          <div className="typing-dot"></div>
          <div className="typing-dot"></div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
